export default __webpack_public_path__ + "static/All-Inclusive-Sales-Management-2e0fa828a43ab239132143a1b5be01a4.webp";